import React from "react";
import "./StepProgressBar.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface IStepProgressBarProps {
  steps: number[];
  signUpStep: number;
  showDone?: boolean;
  backRoute?: string;
}

const StepProgressBar = (props: IStepProgressBarProps) => {
  const { t, ready } = useTranslation();
  if (!ready) {
    return null;
  }
  const { steps, signUpStep, showDone, backRoute } = props;
  const totalStep = steps.length;
  const stepNo = signUpStep > totalStep ? totalStep : signUpStep;
  const isInProgress = stepNo + 1 < totalStep;

  const label =
    isInProgress || !showDone
      ? t("common.stepProgress", { stepNo: stepNo + 1, totalStep })
      : t("common.stepProgressDone");

  /* A fraction, not a percentage: the fill has to be measured against the
     inset track rather than the wrapper, and only the stylesheet knows the
     inset. See `.stepper-track-fill`. */
  const progressFraction = totalStep > 1 ? Math.min(1, Math.max(0, stepNo / (totalStep - 1))) : 0;

  return (
    <div className="stepper-container">
      <div className="stepper-header">
        {backRoute ? (
          <Link to={backRoute} className="stepper-back-btn" id="stepper-back-button" aria-label={t("common.back")}>
            <i className="bi bi-arrow-left" />
            <span>{t("common.back")}</span>
          </Link>
        ) : (
          <div className="stepper-back-spacer" />
        )}
        <span className="step-label">{label}</span>
      </div>
      <div className="stepper-wrapper">
        <div className="stepper-track-bg" />
        <div className="stepper-track-fill" style={{ "--stepper-progress": progressFraction } as React.CSSProperties} />
        {steps.map((_, index) => (
          <div
            key={index}
            className={`stepper-item ${index < stepNo ? "completed" : ""} ${index === stepNo ? "active" : ""}`}
          >
            <div className="step-counter" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepProgressBar;
